import * as React from 'react'

import FormLayout from './layouts/FormLayout'
import GroupedFormLayout from './layouts/GroupedFormLayout'
import ExhibitorLayout from './layouts/ExhibitorLayout'

import useReducer from '@store/useReducer'
import * as AuthStore from '@store/auth/auth'

import useBreakpoint from '@utils/useBreakpoints'

import { AuthScope } from '@api/enum'

const IncidentLayout = (props: IncidentLayoutProps) => {
  const scopes = useReducer(AuthStore.store, (s) => s.scopes)
  const [, bp] = useBreakpoint()

  const fullFormScopes = [AuthScope.SitesTousLecture, AuthScope.SitesUtilisateurLecture]

  const Layout = React.useMemo(
    () =>
      bp === 'phone'
        ? GroupedFormLayout
        : !fullFormScopes.find((s) => scopes.includes(s))
        ? ExhibitorLayout
        : FormLayout,
    [scopes, bp]
  )

  return <Layout {...props} />
}

export default IncidentLayout
